import React, { useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import AppLoader from '../../../App/AppLoader'
import AuthPage from '../../../Shared/AuthPage'
import Form from './Form'

import { getColumns } from '../../../../utils/databases'
import { sort, padArray } from '../../../../utils/arrays'
import { getDatabases, fetchDatabases } from '../../../../ducks/databases'
import { getCurrentOrganizationId } from '../../../../ducks/users'
import { createView } from '../../../../ducks/views'
import { FullScreenLoader } from '../../../Shared/Loading'

const getNewest = dbs => {
  const sorted = sort(dbs, db => db.createdAt)

  return sorted[sorted.length - 1]
}

const getFormattedText = array => {
  return padArray(
    array.map(c => ({ column: c.name, label: c.displayName })),
    ''
  )
}

const getInitialValues = database => {
  const initialValues = {}

  for (let table of database.schema) {
    const { name } = table

    const infoText = getFormattedText(
      getColumns(table, { labelColumn: false }).slice(0, 1)
    )

    const detailsFields = getFormattedText(
      getColumns(table, { hasManys: true })
    )

    initialValues[name] = {
      enabled: true,
      type: 'database',
      name: table.name,
      body: {
        infoText,
        detailsFields,
        databaseId: database.id,
        table: table.name,
        sort: { column: table.labelColumn, direction: 'asc' },
        labelColumn: table.labelColumn || table.primaryKey,
      },
    }
  }

  return initialValues
}

export default function ViewSetup() {
  const dispatch = useDispatch()
  const history = useHistory()
  const organizationId = useSelector(getCurrentOrganizationId)

  const handleSubmit = useCallback(
    async values => {
      const valuesArray = Object.values(values)
        .filter(val => val.enabled)
        .map(val => ({
          ...val,
          enabled: undefined,
        }))

      for (let view of valuesArray) {
        await dispatch(createView(organizationId, view))
      }

      history.push('/')
    },
    [history, dispatch, organizationId]
  )

  return (
    <AppLoader>
      <AuthPage>
        <FormWrapper onSubmit={handleSubmit} />
      </AuthPage>
    </AppLoader>
  )
}

const FormWrapper = function FormWrapper({ onSubmit }) {
  const dispatch = useDispatch()
  const orgId = useSelector(getCurrentOrganizationId)
  const databases = useSelector(getDatabases(orgId))

  useEffect(() => {
    dispatch(fetchDatabases(orgId))
  }, [dispatch, orgId])

  const database = getNewest(databases)

  if (!database) {
    return <FullScreenLoader />
  }

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={getInitialValues(database)}
      database={database}
    />
  )
}
